import { AfterViewChecked, Component, ElementRef, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';
import { FiremessagingService } from 'src/app/services/firebase-messaging/firemessaging.service';
import { GetAllChatsModel } from '../../models/get-all-chats.model';
import { GetChatHistoryModel } from '../../models/get-chat-history.model';
import { MessageModel } from '../../models/message.model';
import { SendChatMessageModel } from '../../models/send-chat-message.model';
import { ChatService } from '../../services/chat/chat-service';

@Component({
  selector: 'app-chat',
  templateUrl: './chat.component.html',
  styleUrls: ['./chat.component.scss']
})
export class ChatComponent implements OnInit, OnDestroy, AfterViewChecked {
  @ViewChild('scrollMe') private myScrollContainer: ElementRef;

  chatRequest = new GetChatHistoryModel();
  chatData: GetAllChatsModel;
  messages: Array<MessageModel>;
  myMsg: any = "";

  messageSend: boolean = false;
  public spinner: boolean = false;

  constructor(
    public ref: DynamicDialogRef,
    public config: DynamicDialogConfig,
    private chatService: ChatService,
    private firebaseService: FiremessagingService,
  ) {
    if (this.config.data != undefined && this.config.data.chatRequest) {
      this.chatRequest = this.config.data.chatRequest;
    }
  }

  ngOnInit(): void {
    this.getChatHistory();
    this.firebaseService.currentMessage.subscribe((msg: any) => {
      if (this.chatData.id == msg.subscriberChatId) {
        this.messages = this.messages.concat(msg);
      }
    })

    this.scrollToBottom();
  }

  getChatHistory(){
    this.spinner = true;
    this.chatService.getchathistory(this.chatRequest).subscribe((response: GetAllChatsModel) => {
      this.spinner = false;
      this.chatData = response;
      this.messages = response.messages;
    }, (error) => {
      this.spinner = false;
    });
  }

  sendMessage(myMsg: string) {
    const model = new SendChatMessageModel();
    model.eventId = this.chatRequest.EventId;
    model.subscriberChatId = this.chatRequest.SubscriberChatId;
    model.subscriberId = this.chatRequest.SubscriberId;
    model.message = myMsg;

    this.chatService.sendchatmessage(model).subscribe(response => {
      this.myMsg = "";
      this.messageSend = true;
      this.chatService.getchathistory(this.chatRequest).subscribe(response => {
        this.chatData = response;
        this.messages = response.messages;
      })
    });
  }

  scrollToBottom(): void {
    try {
      this.myScrollContainer.nativeElement.scrollTop = this.myScrollContainer.nativeElement.scrollHeight;
    } catch (err) { }
  }

  ngOnDestroy(): void {
    this.ref.close(this.messageSend);
  }

  ngAfterViewChecked() {
    this.scrollToBottom();
  }

}
